import { render } from "./SchedulePage.vue?vue&type=template&id=be171eae&ts=true"
import script from "./SchedulePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchedulePage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/schedule/SchedulePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be171eae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be171eae', __exports__)) {
    api.reload('be171eae', __exports__)
  }
  
  module.hot.accept("./SchedulePage.vue?vue&type=template&id=be171eae&ts=true", () => {
    api.rerender('be171eae', render)
  })

}


export default __exports__